import React, { useState } from 'react';
import { useUser } from '../Auth/UsersContext';
import { getAuth, signOut, updateProfile } from "firebase/auth";
import { app, db } from '../Admin/Config/Config';
import { useNavigate } from 'react-router-dom';
import { doc, updateDoc } from 'firebase/firestore';
import { User, Mail, Phone, MapPin, Edit2, LogOut, Camera, Shield } from 'lucide-react';

export default function Profile() {
  const { user } = useUser();
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: user?.name || "",
    mobile: user?.mobile || "",
    district: user?.district || "",
  });
  // const [profileImage, setProfileImage] = useState(null);

  // useEffect(() => {
  //   const auth = getAuth(app);
  //   if (auth.currentUser?.photoURL) {
  //     setProfileImage(auth.currentUser.photoURL);
  //   }
  // }, []);

  const handleLogout = () => {
    const auth = getAuth(app);
    signOut(auth)
      .then(() => {
        navigate('/');
      })
      .catch((error) => {
        console.error("Error signing out:", error);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      const auth = getAuth(app);
      const userRef = doc(db, "users", user.uid);
      
      await updateDoc(userRef, {
        name: formData.name,
        mobile: formData.mobile,
        district: formData.district,
      });

      if (auth.currentUser) {
        await updateProfile(auth.currentUser, {
          displayName: formData.name
        });
      }

      setIsEditing(false);
      window.location.reload();
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  return (
    <div className="min-h-screen bg-black">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="max-w-6xl mx-auto">
          
          <div className="relative mb-8">
            
            <div className="h-48 sm:h-56 rounded-2xl overflow-hidden relative">
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-950 via-gray-900 to-emerald-950">
                <div className="absolute inset-0 opacity-40" style={{ 
                  backgroundImage: 'linear-gradient(90deg, rgba(16,185,129,0.05) 1px, transparent 1px), linear-gradient(0deg, rgba(16,185,129,0.05) 1px, transparent 1px)',
                  backgroundSize: '32px 32px'
                }}></div>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
            </div>
            
        
            <div className="absolute -bottom-16 sm:-bottom-20 left-4 right-4 sm:left-8 sm:right-8">
              <div className="flex flex-col sm:flex-row items-start sm:items-end gap-6 sm:gap-8 sm:justify-between">
             
                <div className="flex flex-col sm:flex-row items-start sm:items-end gap-4 sm:gap-8 w-full sm:w-auto">
                
                  <div className="relative">
                    <div className="w-28 h-28 rounded-full bg-black sm:w-32 sm:h-32  overflow-hidden ring-2 ring-emerald-500/20 border border-emerald-500/10 shadow-2xl">
                      <img
                          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQACGFpr0iqURE_6EHYMm-AGXfhXC1Nzf4ucA&s"
                        alt="Profile"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <button className="absolute bottom-0 right-0 p-2.5 rounded-lg bg-emerald-500/10 hover:bg-emerald-500/20 transition-colors backdrop-blur-sm border border-emerald-500/10">
                      <Camera className="w-4 h-4 text-emerald-400" />
                    </button>
                  </div>
                  
             
                  <div className="sm:mb-2">
                    {isEditing ? (
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="text-2xl sm:text-3xl font-medium bg-black/20 text-white border border-emerald-500/20 rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-500/30 mb-3 w-full sm:w-[320px] backdrop-blur-sm"
                        placeholder="Your Name"
                      />
                    ) : (
                      <h1 className="text-2xl sm:text-3xl font-medium text-white mb-3">{user?.name || "User Name"}</h1>
                    )}
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
                      <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-black/40 backdrop-blur-sm border border-emerald-500/10 w-full sm:w-auto">
                        <Mail className="w-4 h-4 text-emerald-400" />
                        <p className="text-sm text-gray-300 truncate">{user?.email || "email@example.com"}</p>
                      </div>
                    </div>
                  </div>
                </div>

   
                <div className="flex items-center gap-2.5 w-full sm:w-auto">
                  {!isEditing ? (
                    <button
                      onClick={() => setIsEditing(true)}
                      className="flex-1 sm:flex-none px-5 py-2.5 bg-emerald-500/10 hover:bg-emerald-500/20 text-emerald-400 rounded-xl transition-colors flex items-center justify-center gap-2 text-sm border border-emerald-500/20"
                    >
                      <Edit2 className="w-4 h-4" />
                      Edit Profile
                    </button>
                  ) : (
                    <>
                      <button
                        onClick={handleSubmit}
                        className="flex-1 sm:flex-none px-5 py-2.5 bg-emerald-600 hover:bg-emerald-500 text-white rounded-xl transition-colors flex items-center justify-center gap-2 text-sm"
                      >
                        Save Changes
                      </button>
                      <button
                        onClick={() => setIsEditing(false)}
                        className="flex-1 sm:flex-none px-5 py-2.5 bg-black/40 text-white/80 rounded-xl transition-colors text-sm border border-white/10"
                      >
                        Cancel
                      </button>
                    </>
                  )}
                  <button 
                    onClick={handleLogout}
                    className="flex-1 sm:flex-none px-5 py-2.5 bg-red-500/10 hover:bg-red-500/20 text-red-500 rounded-xl transition-colors flex items-center justify-center gap-2 text-sm border border-red-500/20"
                  >
                    <LogOut className="w-4 h-4" />
                    Sign Out
                  </button>
                </div>
              </div>
            </div>
          </div>

  
          <div className="mt-24 sm:mt-32">
          
            <div className="bg-gradient-to-b from-emerald-950/50 to-gray-900/50 rounded-2xl overflow-hidden border border-emerald-500/10">
              <div className="px-8 py-5 border-b border-emerald-500/10 flex items-center justify-between bg-black/20">
                <h2 className="text-xl font-medium text-white flex items-center gap-3">
                  <div className="p-2.5 rounded-lg bg-emerald-500/10 text-emerald-400 ring-1 ring-emerald-500/20">
                    <User className="w-5 h-5" />
                  </div>
                  Personal Information
                </h2>
              </div>

              <div className="p-8">
                <div className="grid md:grid-cols-2 gap-8">
                  
                  <div className="space-y-6">
                    <div className="group bg-black/40 hover:bg-black/60 transition-colors rounded-xl p-6 border border-emerald-500/10">
                      <div className="flex items-center gap-4">
                        <div className="p-3.5 rounded-lg bg-emerald-500/10 text-emerald-400 ring-1 ring-emerald-500/20">
                          <Phone className="w-5 h-5" />
                        </div>
                        <div className="flex-1">
                          <p className="text-sm font-medium text-emerald-400 mb-2">Phone Number</p>
                          {isEditing ? (
                            <input
                              type="text"
                              name="mobile"
                              value={formData.mobile}
                              onChange={handleChange}
                              className="w-full text-base bg-black/40 text-white border border-emerald-500/20 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-emerald-500/30 transition-colors placeholder:text-white/30"
                              placeholder="Enter phone number"
                            />
                          ) : (
                            <p className="text-base text-white">{user?.mobile || "Not provided"}</p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="group bg-black/40 hover:bg-black/60 transition-colors rounded-xl p-6 border border-emerald-500/10">
                      <div className="flex items-center gap-4">
                        <div className="p-3.5 rounded-lg bg-emerald-500/10 text-emerald-400 ring-1 ring-emerald-500/20">
                          <MapPin className="w-5 h-5" />
                        </div>
                        <div className="flex-1">
                          <p className="text-sm font-medium text-emerald-400 mb-2">Location</p>
                          {isEditing ? (
                            <input
                              type="text"
                              name="district"
                              value={formData.district}
                              onChange={handleChange}
                              className="w-full text-base bg-black/40 text-white border border-emerald-500/20 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-emerald-500/30 transition-colors placeholder:text-white/30"
                              placeholder="Enter location"
                            />
                          ) : (
                            <p className="text-base text-white">{user?.district || "Not provided"}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

               
                  <div className="space-y-6">
                    <div className="group bg-black/40 hover:bg-black/60 transition-colors rounded-xl p-6 border border-emerald-500/10">
                      <div className="flex items-center gap-4">
                        <div className="p-3.5 rounded-lg bg-emerald-500/10 text-emerald-400 ring-1 ring-emerald-500/20">
                          <Mail className="w-5 h-5" />
                        </div>
                        <div className="flex-1">
                          <p className="text-sm font-medium text-emerald-400 mb-2">Email Address</p>
                          <p className="text-base text-white">{user?.email || "Not provided"}</p>
                        </div>
                      </div>
                    </div>

                    <div className="group bg-black/40 hover:bg-black/60 transition-colors rounded-xl p-6 border border-emerald-500/10">
                      <div className="flex items-center gap-4">
                        <div className="p-3.5 rounded-lg bg-emerald-500/10 text-emerald-400 ring-1 ring-emerald-500/20">
                          <Shield className="w-5 h-5" />
                        </div>
                        <div className="flex-1">
                          <p className="text-sm font-medium text-emerald-400 mb-2">Account Status</p>
                          <div className="flex items-center gap-2">
                            <div className="w-2 h-2 rounded-full bg-emerald-400"></div>
                            <p className="text-base text-white">Active</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 